import discoverSearchService from '@d-services/books-search-service/discover-search-service';
import reviewerDirectorySearchService from '@d-services/reviewer-search-service/directory-search-service';
import leaderboardSearchService from '@d-services/reviewer-search-service/leaderboard-search-service';
import CardsStore from '@d-shared/store/cards';
import FollowingStore from '@d-shared/store/following';
import GenresStore from '@d-shared/store/genres';
import BookStore from '@d-store/modules/book';
import BookUserReviewsStore from '@d-store/modules/book-user-reviews';
import BooksSearchStore from '@d-store/modules/books-search';
import DiscoverFeedStore from '@d-store/modules/discover-feed';
import ExplicitContentStore from '@d-store/modules/explicit-content';
import LeaderboardFeedStore from '@d-store/modules/leaderboard-feed';
import ReviewerSearchStore from '@d-store/modules/reviewer-search';
import SearchStore from '@d-store/modules/search';

export default {
  Book: BookStore,
  BookUserReviews: BookUserReviewsStore,
  Cards: CardsStore,
  DiscoverFeed: DiscoverFeedStore,
  'DiscoverFeed/BooksSearch': new BooksSearchStore(discoverSearchService),
  ExplicitContent: ExplicitContentStore,
  Following: FollowingStore,
  LeaderboardFeed: LeaderboardFeedStore,
  'LeaderboardFeed/ReviewerSearch': new ReviewerSearchStore(leaderboardSearchService),
  'ReviewerDirectory/ReviewerSearch': new ReviewerSearchStore(reviewerDirectorySearchService),
  'ReviewerDirectory/ReviewerSearch/Genres': new GenresStore(),
  Search: SearchStore,
};
